import { BrowserRouter } from 'react-router-dom';
import { getSeaLinkBasename } from 'utils/helpers';
import { connectedComponent } from 'utils/redux/providerWrapper';
import BookingManagement from './booking_management';

export const ConnectedManageBooking = connectedComponent(BookingManagement);

export const BookingManagementWrapper = (props) => {
  const basename = getSeaLinkBasename();

  return (
    <BrowserRouter basename={basename}>
      <ConnectedManageBooking
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </BrowserRouter>
  );
};

export default BookingManagement;
